import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { WEEK_BETWEEN_GAP_CSS_VARIABLE } from '../../constants/styles.mjs';
import { FormatWithLinearLocale } from '../../utils/format.mjs';
import CalendarHeader from './CalendarHeader.mjs';

const DEFAULT_MONTH_LABEL_FORMAT = {
  en: "MM yyyy",
  ko: "yyyy\uB144 M\uC6D4"
};
function MonthViewHeader({
  monthDate,
  increaseMonth,
  decreaseMonth,
  monthLabelFormat
}) {
  return /* @__PURE__ */ jsxs(CalendarHeader, { children: [
    /* @__PURE__ */ jsx(CalendarHeader.DateText, { children: /* @__PURE__ */ jsx(
      FormatWithLinearLocale,
      {
        date: monthDate,
        formatMap: monthLabelFormat ?? DEFAULT_MONTH_LABEL_FORMAT
      }
    ) }),
    /* @__PURE__ */ jsxs(CalendarHeader.RightSlot, { children: [
      /* @__PURE__ */ jsx(CalendarHeader.PrevIconButton, { onClick: decreaseMonth }),
      /* @__PURE__ */ jsx(CalendarHeader.NextIconButton, { onClick: increaseMonth })
    ] })
  ] });
}
function MultiMonthViewHeader({
  monthDate,
  increaseMonth,
  decreaseMonth,
  monthLabelFormat,
  customHeaderCount,
  monthsShown
}) {
  return /* @__PURE__ */ jsxs(StyledMultiMonthViewHeader, { justify: "center", children: [
    customHeaderCount === 0 && /* @__PURE__ */ jsx(CalendarHeader.LeftSlot, { children: /* @__PURE__ */ jsx(
      CalendarHeader.PrevIconButton,
      {
        onClick: decreaseMonth,
        css: { position: "absolute", left: 0 }
      }
    ) }),
    /* @__PURE__ */ jsx(CalendarHeader.DateText, { children: /* @__PURE__ */ jsx(
      FormatWithLinearLocale,
      {
        date: monthDate,
        formatMap: monthLabelFormat ?? DEFAULT_MONTH_LABEL_FORMAT
      }
    ) }),
    customHeaderCount === monthsShown - 1 && /* @__PURE__ */ jsx(CalendarHeader.RightSlot, { children: /* @__PURE__ */ jsx(
      CalendarHeader.NextIconButton,
      {
        onClick: increaseMonth,
        css: { position: "absolute", right: 0 }
      }
    ) })
  ] });
}
const StyledMultiMonthViewHeader = styled(CalendarHeader, {
  gap: 0
});
const monthViewOverridingStyles = {
  [WEEK_BETWEEN_GAP_CSS_VARIABLE]: "1px",
  ".react-datepicker__triangle": {
    display: "none"
  },
  ".react-datepicker__month-container": {
    // NOTE: 복수 달일 때 월 별 width 가 변경되는 것을 막기 위함
    flex: 1,
    padding: 10
  },
  ".react-datepicker__header": {
    paddingTop: 0,
    paddingBottom: 4,
    border: "none",
    background: "none",
    "&&": {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    ".react-datepicker__day-names": {
      whiteSpace: "nowrap",
      display: "flex",
      justifyContent: "space-between",
      ".react-datepicker__day-name": {
        display: "inline-block",
        width: "100%",
        minWidth: "32px",
        height: 30,
        lineHeight: "30px",
        textAlign: "center",
        margin: "unset"
      }
    }
  },
  ".react-datepicker__day-names": {
    marginBottom: 0
  },
  ".react-datepicker__day-name": {
    color: "$blackAlpha024",
    fontWeight: 500,
    fontSize: 13
  },
  ".react-datepicker__week": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    ["& + &"]: {
      marginTop: `var(${WEEK_BETWEEN_GAP_CSS_VARIABLE})`
    }
  },
  ".react-datepicker__month": {
    margin: 0
  }
};

export { MonthViewHeader, MultiMonthViewHeader, monthViewOverridingStyles };
//# sourceMappingURL=month.mjs.map
